module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=pattern>*Only .CSV (comma separated values) files allowed</span> ";